import { render, staticRenderFns } from "./ShipmentMetric.vue?vue&type=template&id=3aa74397&scoped=true"
import script from "./ShipmentMetric.vue?vue&type=script&lang=js"
export * from "./ShipmentMetric.vue?vue&type=script&lang=js"
import style0 from "./ShipmentMetric.vue?vue&type=style&index=0&id=3aa74397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa74397",
  null
  
)

export default component.exports